import { observer } from "mobx-react";
import React from "react";
import { AgentControlCircle } from "../../components/call/agentControlCircle";
import styles from "./agentCallSection.css";
import classNames from "classnames";

export interface Props {
  expandVideoButtonClicked: () => void;
  hideVideoButtonClicked: () => void;
  renderCobrowsingButton: () => JSX.Element;
  videoHidden: boolean;
  videoExpanded: boolean;
  isCobrowsingSessionAccepted: boolean;
}

export const CobrowsingButtons = observer(
  ({
    isCobrowsingSessionAccepted,
    expandVideoButtonClicked,
    hideVideoButtonClicked,
    videoHidden,
    videoExpanded,
    renderCobrowsingButton
  }: Props) => {
    return (
      <div className={styles["buttons-container"]}>
        <>
          {isCobrowsingSessionAccepted && (
            <>
              <AgentControlCircle buttonStyle={{ small: true }} onClick={expandVideoButtonClicked}>
                <div className={classNames(styles["small-inside"], styles.expand)}>
                  {(videoExpanded && <i className="icon-minimise-video-icon" />) || (
                    <i className="icon-expand-video-icon" />
                  )}
                </div>
              </AgentControlCircle>
              <AgentControlCircle buttonStyle={{ small: true }} onClick={hideVideoButtonClicked}>
                <div
                  className={classNames(styles["small-inside"], { [styles.rotate]: !videoHidden })}
                >
                  <i className={"icon-arrow-up"} />
                </div>
              </AgentControlCircle>
            </>
          )}
          {renderCobrowsingButton()}
        </>
      </div>
    );
  }
);
